import { useState } from 'react';
import T from 'prop-types';
import Modal from 'react-modal';
import MonitorIcon from '@mui/icons-material/Monitor';
import { Button } from '@/common/components/ui/button';

function getSeatBackground(isEnabled, isReserved, isSelected) {
  if (!isEnabled) return 'bg-site-unavailable'
  if (isReserved) return 'bg-site-reserved'
  if (isSelected) return 'bg-site-selected'
  return 'bg-site-available'
}

function Seat({ isEnabled = true, isReserved = false, isSelected = false, label, isOps = false, onAddSeat, onRemoveSeat, monitors, fullName }) {
  const isAvailable = isEnabled && !isReserved;
  const handleClick = () =>
    isOps ? onAddSeat() : isAvailable && (isSelected ? onRemoveSeat() : onAddSeat());

  const [isModalOpen, setIsModalOpen] = useState(false);

  const seatBg = getSeatBackground(isEnabled, isReserved, isSelected);
  const hoverBg = isEnabled && !isSelected && !isReserved ? 'hover:bg-site-available-hover' : '';
  const cursor = !isOps && (isReserved || !isEnabled) ? 'cursor-not-allowed' : 'cursor-pointer';

  return (
    <div className="relative group">
      <button
        type="button"
        className={`${seatBg} ${hoverBg} ${cursor} h-[35px] w-[52px] flex-none text-white flex justify-center items-center rounded-lg mx-[1px] my-3`}
        onClick={handleClick}
      >
        {label}
      </button>

      <div className="style absolute text-center translate-x-[40%] text-black p-[1px] rounded invisible group-hover:visible">
        <button
          type="button"
          className="icon relative top-[-60px] right-[-3.9px] cursor-pointer h-[30px]"
          data-testid='monitor-icon-button'
          aria-label="Seat information"
          onClick={() => setIsModalOpen(true)}
        >
          <MonitorIcon />
        </button>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        overlayClassName="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
        className="bg-white rounded-xl shadow-lg outline-none w-72"
      >
        <div className="flex flex-col gap-3 p-5">
          <h2 className="text-sm font-semibold text-gray-800">Additional Information</h2>
          <div className="text-sm text-gray-600 space-y-1">
            <p className="font-medium text-gray-700">Monitors: {monitors ?? '—'}</p>
            {fullName && <p className="font-medium text-gray-700">Employee: {fullName}</p>}
          </div>
          <Button variant="outline" size="sm" onClick={() => setIsModalOpen(false)}>
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
}

Seat.propTypes = {
  label: T.oneOfType([T.string, T.number]).isRequired,
  onAddSeat: T.func.isRequired,
  onRemoveSeat: T.func.isRequired,
  monitors: T.oneOfType([T.string, T.number]),
  fullName: T.oneOfType([T.string, T.number]),
};

export default Seat;
